import React, { Component } from 'react';
import LayoutBackoffice from '../../header_footer/LayoutBackoffice';
import FormEssencia from './FormEssencia';

export default class CreateEssencia extends Component {

    render() {
        return (
            <LayoutBackoffice>
                <div className="container">
                    <h2 className="backoffice-titulo-pagina">Adicionar essência</h2>
                    <FormEssencia mode="create" />
                </div>
            </LayoutBackoffice>
        );
    }
}
